module.exports = __webpack_public_path__ + "img/brushes-poster_jp.b8d5c33.jpg";